import { render, staticRenderFns } from "./OrderTotal.vue?vue&type=template&id=9dd55aa2&"
import script from "./OrderTotal.vue?vue&type=script&lang=ts&"
export * from "./OrderTotal.vue?vue&type=script&lang=ts&"
import style0 from "./OrderTotal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports